import React from "react";

// A wallet with a banknote lifting out of it: money going out, for Bills & Payments.
// Drawn in the same outline style as the react-feather icons used elsewhere, and
// takes the same size / color / strokeWidth props so it can sit next to them.
const WalletOutIcon = ({ size = 24, color = "currentColor", strokeWidth = 2, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...rest}
  >
    {/* the note, tilted as it comes out of the wallet */}
    <path d="M6 10 8.2 3.6l10 3.4-1 3" />
    <circle cx="12.6" cy="6.9" r="1.1" />
    {/* wallet body */}
    <path d="M3 10h16a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9z" />
    {/* clasp */}
    <path d="M21 14h-3.5a1.5 1.5 0 0 0 0 3H21" />
  </svg>
);

export default WalletOutIcon;
